import React from 'react'
import { t } from '../i18n'
import { useUi } from '../State/Ui'
import { useSurface } from '../Utils/analytics'
import { shareStory } from '../Utils/share'
import { ShareIcon } from './Icons'

export default function ShareButton({ story, size = 20 }) {
  const { notify } = useUi()
  const surface = useSurface()
  return (
    <button
      type="button"
      className="icon-button share-button"
      aria-label={t('card.share')}
      onClick={(e) => {
        e.stopPropagation()
        shareStory(story, notify, surface)
      }}
    >
      <ShareIcon size={size} />
    </button>
  )
}
